export function makeAlert({msg, className = 'alert alert-orange-500'}) {
    let messageNode = document.createElement('div')
    messageNode.className = 'alert alert-orange-500'
    messageNode.innerHTML = msg
    return messageNode
}
